import { render, staticRenderFns } from "./OrderCookedTime.vue?vue&type=template&id=3b72fe4a&"
import script from "./OrderCookedTime.vue?vue&type=script&lang=ts&"
export * from "./OrderCookedTime.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports